/** The one row Fun is settled over; it has a Fun-only collector, apart from crypto deposits. */
export const FUN_ORIGIN_ASSET_ID = "base-usdc";

/** The destination key a Fun delivery carries, apart from the crypto deposits' `usdc`. */
export const FUN_DESTINATION_ASSET_KEY = "fun-usdc";

/** Lowest Fun deposit minimum we accept, in USD; must stay above the server's $1 dust line. */
export const FUN_MIN_DEPOSIT_FLOOR_USD = 2;

/** Every code the server's fun routes answer a failure envelope with. */
export const FUN_ERROR_CODES = [
  "unsupportedAsset",
  "subaccountRequired",
  "chainUnavailable",
  "funUnavailable",
  "funMainnetOnly",
  "funLookupThrottled",
  "funTransferCryptoThrottled",
] as const;
export type FunErrorCode = (typeof FUN_ERROR_CODES)[number];

/** The id Fun files a user's history under, `key|account`. */
export function funUserId(apiKey: string, account: string): string {
  return `${apiKey}|${account}`;
}
